module.exports = __webpack_public_path__ + "static/img/4.1b115b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/4.png
// module id = aafJ
// module chunks = 0